<div class="offer-bottom-popup">
  <div>
    <ion-card>
      <ion-card-header class="ion-text-center">
        <ion-card-subtitle>
            <ion-icon name="close-outline" (click)="close(false)" style="right: 0;position: absolute;font-size: 2rem;color: #01A3A4;margin:15px 20px;z-index: 999999;"></ion-icon>
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <ion-row>
          <ion-col class="ion-text-center" style="font-weight: 500;padding: 5px;">
            <span style="font-size: 1.2rem;color:#01A3A4 ;">Select Slot</span>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-text-center green-msg">
            <ion-list>
              <ion-item *ngFor="let slot of foodSlots;let i=index;" (click)="slotSelected(slot,i)">
                <ion-label>
                  <h2>{{slot.name}}</h2>
                </ion-label>
                <ion-toggle slot="end" [(ngModel)]="slot.isSelected" checked="{{slot?.isSelected}}"></ion-toggle>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

        <ion-row class="text-center" style="margin: 15px;">
          <!-- <ion-col>
            <ion-button size="default" shape="round" fill='outline' class="retry-btn" (click)="close(true)">
              Add
            </ion-button>
          </ion-col> -->
          <ion-col>
            <ion-button size="default" shape="round" (click)="close(true)" style="--background: #01A3A4;width: 50%;">
              Add
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-card-content>
    </ion-card>
  </div>
</div>